import { DatePicker } from "antd";
import styled from 'styled-components';

export default styled(DatePicker)`

`;